






























































import { Collection } from "@/models/products/collection";
import { Vue, Component, Prop } from "vue-property-decorator";
import Collections from "./Collections";
import { ProductType } from "@/models/products/product";
import { getImg } from "@/utility/helpers";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
@Component({
  components: {
    AccordionSection
  }
})
export default class ChairMenu extends Collections {
  protected getImg = getImg;
}
